import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resources } from './local';

// Detect browser language
const getBrowserLanguage = (): string => {
  const browserLang = navigator.language || (navigator as any).userLanguage;
  
  // Check if browser language is Arabic
  if (browserLang.startsWith('ar')) {
    return 'ar';
  }
  
  // Default to English for all other languages
  return 'en';
};

const defaultLanguage = getBrowserLanguage();

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: defaultLanguage,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    defaultNS: 'common'
  });

// Set initial direction
document.documentElement.lang = defaultLanguage;
document.documentElement.dir = defaultLanguage === 'ar' ? 'rtl' : 'ltr';

export default i18n;
